import { render, staticRenderFns } from "./giftcards-items.vue?vue&type=template&id=4358ab63&scoped=true&"
import script from "./giftcards-items.vue?vue&type=script&lang=js&"
export * from "./giftcards-items.vue?vue&type=script&lang=js&"
import style0 from "./giftcards-items.vue?vue&type=style&index=0&id=4358ab63&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4358ab63",
  null
  
)

export default component.exports